import { useEffect, useState } from "react";

/* ─────────────────────────────────────────────
   IMAGE IMPORTS — src/assets/images/blogs/
───────────────────────────────────────────── */
import HeroImg             from "../../assets/images/blogs/ola-electric-detail.webp";
import HeroImgMobile       from "../../assets/images/blogs/ola-electric-mobile.webp";
import NewsletterBgDesktop from "../../assets/images/blogs/newsletter-bg.webp";
import NewsletterMicMobile from "../../assets/images/blogs/newsletter-bg-mobile.webp";
import TweetBhavish        from "../../assets/images/blogs/tweet-bhavish-ola.webp";
import InlineImgOlaCar     from "../../assets/images/blogs/ola-electric-car.webp";

/* ─────────────────────────────────────────────
   IsOLAElectricAmbitionsForEVsInIndiaFlawed.jsx
   Prefix      : bd-
   Fonts       : Montserrat (headings) | Roboto (body)
   Purple      : #743FAC
   BG main     : #1A1A1A
   Inner pad   : 102px desktop | 32px tab | 16px mobile
   Breaks      : 768px | 480px
   Anim        : IntersectionObserver fade-up
                 delays 0.08s / 0.18s / 0.28s / 0.38s
─────────────────────────────────────────────── */

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Roboto:wght@300;400;500;700&display=swap');

  .bd-wrap *, .bd-wrap *::before, .bd-wrap *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .bd-wrap {
    font-family: 'Roboto', sans-serif;
    background: #1A1A1A;
    color: #ffffff;
    width: 100%;
    overflow-x: hidden;
  }
  .bd-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
    width: 100%;
  }
  .bd-content-col { width: 100%; }

  /* ── SCROLL FADE-UP ── */
  .bd-fade-up {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .bd-fade-up.bd-in { opacity: 1; transform: translateY(0); }
  .bd-delay-1 { transition-delay: 0.08s; }
  .bd-delay-2 { transition-delay: 0.18s; }
  .bd-delay-3 { transition-delay: 0.28s; }
  .bd-delay-4 { transition-delay: 0.38s; }

  /* ══════════════════════════════════════
     HERO
  ══════════════════════════════════════ */
  .bd-hero { width: 100%; background: #000000; }
  .bd-hero__title-bar {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0px;
  }
  .bd-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    text-align: center;
  }
  .bd-hero__img-wrap {
    width: 100%;
    max-height: 620px;
    overflow: hidden;
  }
  .bd-hero__img-wrap img {
    width: 100%;
    height: 100%;
    max-height: 620px;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  /* ══════════════════════════════════════
     BODY CONTENT
  ══════════════════════════════════════ */
  .bd-body-section {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0 100px;
  }

  /* italic opening quote */
  .bd-quote {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    font-style: italic;
    line-height: 160%;
    color: #E2E2E2;
    margin-bottom: 24px;
  }

  .bd-para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 160%;
    color: #E2E2E2;
    margin-bottom: 24px;
  }

  /* standard subhead */
  .bd-subhead {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 160%;
    margin-bottom: 14px;
    margin-top: 44px;
  }

  /* tweet screenshot — left aligned, 424px — image 2 */
  .bd-tweet-img-wrap {
    margin: 44px 0;
    max-width: 424px;
  }
  .bd-tweet-img-wrap img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
  }

  /* inline content image — left aligned, 624px — image 4 */
  .bd-inline-img-wrap {
    margin: 44px 0;
    width: 923px;
    max-width: 100%;
  }
  .bd-inline-img-wrap img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
  }

  /* ══════════════════════════════════════
     NEWSLETTER
  ══════════════════════════════════════ */
  .bd-newsletter {
    width: 100%;
    position: relative;
    overflow: hidden;
    min-height: 500px;
    display: flex;
    align-items: center;
  }
  .bd-newsletter__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
   
    object-position: center;
    z-index: 0;
  }
  .bd-newsletter__overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
  }
  .bd-newsletter__inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0px 102px;
  }
  .bd-newsletter__heading {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 14px;
  }
  .bd-newsletter__sub {
    font-family: 'Roboto', sans-serif;
    font-size: 15px;
    color: rgba(255,255,255,0.72);
    line-height: 160%;
    margin-bottom: 24px;
  }
  .bd-newsletter__form {
    display: flex;
    align-items: stretch;
    max-width: 552px;
    gap: 14px;
  }
  .bd-newsletter__input {
    flex: 1;
    height: 48px;
    background: #1A1A1A;
    border: 1px solid #ffffff;
    border-radius: 5px;
    padding: 15px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    color: #FFFFFF;
    outline: none;
  }
  .bd-newsletter__input::placeholder { color: #FFFFFF; }
  .bd-newsletter__btn {
    height: 50px;
    padding: 15px 30px;
    background: #743FAC;
    border: none;
    border-radius: 5px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    transition: background 0.25s ease;
  }
  .bd-newsletter__btn:hover { background: #5e2e90; }
  .bd-newsletter__btn-arrow {
    display: inline-flex;
    align-items: center;
    transition: transform 0.2s ease;
  }
  .bd-newsletter__btn:hover .bd-newsletter__btn-arrow { transform: translateX(4px); }
  .bd-newsletter__mic-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
  .bd-newsletter__content { padding: 0; }

  /* ══════════════════════════
     RESPONSIVE 768px
  ══════════════════════════ */
  @media (max-width: 768px) {
    .bd-inner { padding-left: 32px; padding-right: 32px; }
    .bd-hero__img-wrap img { max-height: 350px; }
    .bd-hero__title-bar { padding: 24px 32px 20px; }
    .bd-hero__title { font-size: 24px; }
    .bd-body-section { padding: 40px 0 48px; }
    .bd-para { margin-bottom: 18px; font-size: 15px; }
    .bd-quote { font-size: 15px; margin-bottom: 18px; }
    .bd-subhead { font-size: 18px; margin-top: 28px; margin-bottom: 10px; }
    .bd-tweet-img-wrap { max-width: 100%; margin: 28px 0; }
    .bd-inline-img-wrap { width: 450px; margin: 28px 0 0 0; }

    .bd-newsletter {
      min-height: auto;
      align-items: stretch;
      flex-direction: column;
      background: #1A1A1A;
    }
    .bd-newsletter__mic-img { width: 100%; height: 350px; object-fit: cover; }
    .bd-newsletter__inner {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .bd-newsletter__content {
      padding: 40px 24px 48px;
      text-align: center;
    }
    .bd-newsletter__heading { font-size: 24px; }
    .bd-newsletter__sub { font-size: 14px; margin: 0 auto 24px; }
    .bd-newsletter__form {
      flex-direction: column;
      max-width: 100%;
      gap: 12px;
    }
    .bd-newsletter__input { border-radius: 5px; height: 44px; }
    .bd-newsletter__btn {
      border-radius: 5px;
      justify-content: center;
      height: 44px;
    }
  }

  /* ══════════════════════════
     RESPONSIVE 480px
  ══════════════════════════ */
  @media (max-width: 480px) {
    .bd-inner { padding-left: 16px; padding-right: 16px; }
    .bd-hero__title-bar { padding: 30px 16px; }
    .bd-body-section { padding: 30px 0 30px; }
    .bd-hero__img-wrap img { max-height: 366px; width: 100%; }
    .bd-hero__title { font-size: 30px; line-height: 120%; }
    .bd-para { font-size: 14px; margin-bottom: 14px; }
    .bd-quote { font-size: 14px; margin-bottom: 14px; }
    .bd-subhead { margin-top: 30px; margin-bottom: 14px; font-size: 16px; }
    .bd-tweet-img-wrap { margin: 30px 0; max-width: 100%; }
    .bd-inline-img-wrap { width: 100%; margin: 30px 0 0 0; }

    .bd-newsletter {
      min-height: auto;
      align-items: stretch;
      flex-direction: column;
      background: #1A1A1A;
    }
    .bd-newsletter__mic-img { width: 100%; height: 366px; object-fit: cover; }
    .bd-newsletter__inner {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .bd-newsletter__content {
      padding: 30px 16px 40px;
      text-align: center;
    }
    .bd-newsletter__heading { font-size: 30px; line-height: 120%; }
    .bd-newsletter__sub { font-size: 14px; max-width: 275px; margin: 0 auto 24px; }
    .bd-newsletter__form {
      flex-direction: column;
      max-width: 100%;
      gap: 15px;
      margin-top: 15px;
    }
    .bd-newsletter__input { border-radius: 5px; height: 40px; font-size: 14px; }
    .bd-newsletter__btn {
      border-radius: 5px;
      justify-content: center;
      height: 40px;
      font-size: 14px;
    }
  }
`;

/* ── SCROLL REVEAL ── */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".bd-fade-up");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("bd-in"); }),
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

/* ── ARROW ── */
function ArrowRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/* ── NEWSLETTER ── */
function Newsletter({ isMobile }) {
  const [email, setEmail] = useState("");
  return (
    <section className="bd-newsletter">
      {!isMobile && (
        <>
          <img className="bd-newsletter__bg" src={NewsletterBgDesktop} alt="" aria-hidden="true" />
          <div className="bd-newsletter__overlay" />
        </>
      )}
      <div className="bd-newsletter__inner">
        {isMobile && (
          <img className="bd-newsletter__mic-img" src={NewsletterMicMobile} alt="Microphone" />
        )}
        <div className="bd-newsletter__content">
          <h2 className="bd-newsletter__heading">Sign up for our<br />newsletter!</h2>
          <p className="bd-newsletter__sub">Get notified about updates and be the first to get early access to new episodes.</p>
          <div className="bd-newsletter__form">
            <input
              className="bd-newsletter__input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="bd-newsletter__btn">
              Subscribe
              <span className="bd-newsletter__btn-arrow"><ArrowRight /></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── ROOT EXPORT ── */
export default function IsOLAElectricAmbitionsForEVsInIndiaFlawed() {
  useScrollReveal();

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const [isSmallMobile, setIsSmallMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 480px)");
    setIsSmallMobile(mq.matches);
    const handler = (e) => setIsSmallMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <>
      <style>{CSS}</style>
      <div className="bd-wrap">

        {/* HERO */}
        <section className="bd-hero">
          <div className="bd-hero__title-bar">
            <h1 className="bd-hero__title">Is OLA Electric's ambitions for EVs in India flawed?</h1>
          </div>
          <div className="bd-hero__img-wrap">
            <img
              src={isSmallMobile ? HeroImgMobile : HeroImg}
              alt="OLA Electric"
            />
          </div>
        </section>

        {/* BODY */}
        <section className="bd-body-section">
          <div className="bd-inner">
            <div className="bd-content-col">

              {/* italic opening quote — image 1 */}
              <p className="bd-quote bd-fade-up bd-delay-1">
                "Potential investors and customers are attracted to the electric car as a mirage. Seems Ola Electric must sort out its electric scooter first."
              </p>

              <p className="bd-para bd-fade-up bd-delay-1">Nitin Gadkari, India's transport minister, has pushed for the far-fetched goal of having solely electric vehicles on Indian roads by 2030. By the end of the decade, the goal is to electrify 30% of personal automobiles, 70% of commercial vehicles, 40% of buses, and 80% of two-wheelers. Since then, the electric vehicle business has grown rapidly, with both established automakers and new entrants. Because India's electric vehicle market is still in its infancy, every firm in the field, whether established or rising, is attempting to improve its position. Among them is Bhavish Aggarwal, the co-founder of Ola Cabs, a popular ridesharing startup that served the Indian EV market in 2017.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Ola Electric was founded as a wholly-owned subsidiary of ANI Technologies in 2017. To diminish pollution and fuel dependency on Ola's cabs by converting them to mainstream electric mobility, a pilot program was launched in Nagpur, which included the installation of charging stations throughout the city and the purchase of electric taxis, e-buses, and e-rickshaws from OEM partners. Around April 2018, Ola Electric announced its 'Mission Electric,' which aims to have 1 million electric vehicles on the road by 2025. By acting quickly, founder Bhavish Aggarwal purchased 92.5% of Ola Electric from ANI Technologies in December 2018 for 1,300$ US and spun it off as a separate business in January 2019; in exchange for the right to use the "Ola" name.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Ola Electric's plant is in Pochampalli, Tamil Nadu's Krishnagiri district, and spans 500 acres. It claims to be the world's largest two-wheeler facility, with a production capacity of 10 million units per year and a production rate of one scooter every two seconds. What drew first gained attention for its Ola Electric scooter models S1 and S1 Pro, even more, was the fact that the Pochampalli plant would employ over 10,000 women, making it the world's largest factory entirely dedicated to women. To become the world's "largest, most sophisticated, and most environmentally friendly" two-wheeler manufacturer.</p>

              <p className="bd-para bd-fade-up bd-delay-1">But it's worth noting that the scooter's marketing promises about its luxurious features, advanced software, and quick online purchasing facility lured in additional buyers. Apart from its aspirations to build a future facility, Ola Electric also aspires to be the premium e-scooter brand for the electric vehicle sector and develop its Hypercharging network across the country. Long before it began delivering scooters, it launched its first Hypercharge station at Bengaluru's Ola Campus in October 2021. This clarified that the 'Indian Electric Vehicle Revolution' might have come closer.</p>

              {/* subhead — image 2 */}
              <h2 className="bd-subhead bd-fade-up bd-delay-1">What funding streams did Ola Electric secure to support its ambitious vision?</h2>

              <p className="bd-para bd-fade-up bd-delay-1">However, as is commonly stated, ambitious ideas need a great deal of bravery, and they frequently confront multiple hurdles along the road. One of them was being funded to fulfil its vision and aims of riding into India's EV Revolution, but to its surprise, Ola Electric raised incredible funds throughout its investment rounds with the glamour and ideas of accelerating India's EV industry by becoming one of the big participants. Ola Electric raised US$56 million in February 2019 from Tiger Global and Matrix India to realize its dreams and ambitions for its electric scooters. It announced on May 6, 2019, that Ratan Tata had invested an undisclosed sum in the company as part of its Series A round of funding. It raised $250 million in a Series B round of funding from SoftBank in July 2019, valuing the company at over $1 billion and making it India's first unicorn in a series of funding.</p>

              <p className="bd-para bd-fade-up bd-delay-1">It also secured more than $200 million in September 2021 from Falcon Edge, SoftBank Group, and others for a $3 billion valuation. In December of that year, it raised $53 million in an investment round sponsored by Singaporean holding company Temasek. Ola Electric secured $200 million in January 2022 from a variety of investors, valuing the company at a total of $5 billion.</p>

              {/* tweet screenshot image — image 2, left aligned 424px */}
              <div className="bd-tweet-img-wrap bd-fade-up bd-delay-2">
                <img src={TweetBhavish} alt="Tweet - Bhavish Aggarwal on OLA Electric" />
              </div>

              {/* subheads — image 3 */}
              <h2 className="bd-subhead bd-fade-up bd-delay-1">How strong was the glitz of Ola Electric's electric scooter?</h2>

              <p className="bd-para bd-fade-up bd-delay-1">Ola Electric went over and above to build a reputation for its electric scooters, with 500,000 bookings in its first month of operation. The Ola Electric Scooter, according to the manufacturer, boasts exceptional performance and charging speed. Furthermore, the top-spec model has a range of over 181 kilometers and will probably definitely provide more than 135 kilometers in real life, making it appear incredibly impressive. It sparked even more interest because of its great customer service, low booking costs, and lofty objectives, which border on the outrageous considering its boasts of a 10-million-unit capacity.</p>

              <h2 className="bd-subhead bd-fade-up bd-delay-1">Has Ola Electric become a premium brand for its Electric two-wheeler based on its vision statement?</h2>

              <p className="bd-para bd-fade-up bd-delay-1">Exactly, NO! Things aren't operating as intended for certain consumers, despite a brand based on enthusiasm, some best-in-class features, and a promising product. Ola Electric has had production delays, and several customers are dissatisfied with the quality of the scooters they received, which lacked several promised features. Ola Electric customers were also concerned about the installation dates of home chargers as well as insurance policy issues.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Where the customer was dealing with these dilemmas, the scooter did not receive entirely positive reviews in terms of the standards and performance aimed by Ola, with complaints about the scooter's lack of range, unlocking while charging, body defects, headlight-screening noises, no smooth navigation features, touch screen issues, being unable to contact customer service, having the scooter serviced within the first month of purchase, and many more flooding the Ola Electric Twitter handler. Additionally, in an event for journalist Ola scooters missed the major features promised for the scooter and got into reverse mode, sparking even another uproar. The terrifying occurrence occurred when word broke that a customer had a strange failure that led an Ola S1 Pro e-scooter to shift into reverse mode at a speed of 102 kilometers per hour. (Yikes!)</p>

              <h2 className="bd-subhead bd-fade-up bd-delay-1">For potential investors and purchasers, again another mirage?</h2>

              <p className="bd-para bd-fade-up bd-delay-1">Ola Electric has been plagued by not just delays in the delivery of its electric scooters, but also dissatisfied consumers. However, when Bhavish hinted at it on Twitter, the media went crazy; with the debut of electric scooters, the company stated that it will produce an electric automobile by 2023. The business is currently working on a handful of more concept designs for its next four-wheeler. Furthermore, because the current Ola Future factory can only produce two-wheelers, the firm will very surely need to grow capacity, which will almost certainly be achieved by building a second Future factory-style vehicle production facility. So, how does it intend to debut its electric four-wheeler amid a global electric chip shortage? Will the electric automobile, like its electric scooters, a surge in the marketplace unprepared? there are a few unsolved questions.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Ola Electric's series of milestones look to be missing in different areas, despite a rush of capital and regular new ideas and objectives. Customers who did receive their scooters have complained about the decreased range and other anomalies, not to mention the fact that delivery has been delayed. Several consumers contacted FADA for assistance. FADA has struggled to find a solution because Ola Electric does not have any dealers; after all, it is a direct-to-consumer business. Despite struggling to achieve its electric scooter supply deadlines after entering the EV Indian market, the company has hinted at a future move into EVs. Except for the teaser electric automobile image, Bhavish did not divulge much about the company's plans to enter the electric four-wheeler sector. Perhaps as result, it is important to remember that the Ola Electric Car will not succeed only due to public excitement because it is a premature pet project. And the problems of unreasonable timelines, imperfect goods, and attrition will further exacerbate the problem. So, it'll be fascinating to watch if Ola aims to be revolutionary in India's 2- and 4-wheeler sectors, and how it might carry out its plans to meet consumer expectations by being more than just a brand built on hearsay and buzz, but by suiting upon its promises.</p>

              {/* inline image — Ola Electric car, 624px wide — image 4 */}
              <div className="bd-inline-img-wrap bd-fade-up bd-delay-2">
                <img src={InlineImgOlaCar} alt="Ola Electric Car concept" />
              </div>

            </div>
          </div>
        </section>

        {/* NEWSLETTER */}
        <Newsletter isMobile={isMobile} />

      </div>
    </>
  );
}